var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShorter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1869_50246)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 6.25C5.08579 6.25 4.75 5.91421 4.75 5.5C4.75 5.08579 5.08579 4.75 5.5 4.75H22.5C22.9142 4.75 23.25 5.08579 23.25 5.5C23.25 5.91421 22.9142 6.25 22.5 6.25H14.75V10.5546L16.2455 9.19504C16.552 8.91641 17.0263 8.939 17.305 9.2455C17.5836 9.55199 17.561 10.0263 17.2545 10.305L14.5045 12.805C14.2184 13.065 13.7816 13.065 13.4955 12.805L10.7455 10.305C10.439 10.0263 10.4164 9.55199 10.695 9.2455C10.9737 8.939 11.448 8.91641 11.7545 9.19504L13.25 10.5546V6.25H5.5ZM11.7545 18.805C11.448 19.0836 10.9737 19.061 10.695 18.7545C10.4164 18.448 10.439 17.9737 10.7455 17.695L13.4955 15.195C13.7816 14.935 14.2184 14.935 14.5045 15.195L17.2545 17.695C17.561 17.9737 17.5836 18.448 17.305 18.7545C17.0263 19.061 16.552 19.0836 16.2455 18.805L14.75 17.4454V21.75H22.5C22.9142 21.75 23.25 22.0858 23.25 22.5C23.25 22.9142 22.9142 23.25 22.5 23.25H5.5C5.08579 23.25 4.75 22.9142 4.75 22.5C4.75 22.0858 5.08579 21.75 5.5 21.75H13.25V17.4454L11.7545 18.805Z",
    fill: "url(#paint0_linear_1869_50246)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1869_50246",
    x: 3.75,
    y: 4.75,
    width: 20.5,
    height: 20.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1869_50246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1869_50246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1869_50246",
    x1: 14,
    y1: 5.54286,
    x2: 14,
    y2: 22.4571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShorter);
export default __webpack_public_path__ + "static/media/ic-shorter.2acb24391b49f56f342868a2df21d31a.svg";
export { ForwardRef as ReactComponent };